(function ($) {
  $.fn.listInitScripts = function () {
    // Bind the slide functionality
    $('.list-items .item').slideList()
  }

  $(document).ready($(this).listInitScripts)
}(jQuery))
